const AccessDenied = () => {
  return (
    <div
      style={{ padding: 40 }}
      className="flex flex-col justify-center items-center w-screen h-screen bg-white gap-4"
    >
      <h2 className="text-2xl font-bold ">🚫 Access Denied</h2>
      <p>You don't have permission to view this page.</p>
    </div>
  );
};

export default AccessDenied;
